/*
 * Htmx init
 *
 * Initialise htmx
 */

import animateScrollTo from 'animated-scroll-to';
import PubSub from 'pubsub-js';

export default class HtmxInit {

    constructor() {

        // security
        htmx.config.selfRequestsOnly = true;
        htmx.config.allowScriptTags = false;
        htmx.config.boostCount = 0;

        // log all events for debugging
        //htmx.logger = function(elt, event, data) {
        //    if(console) {
        //        console.log("INFO:", event, elt, data);
        //    }
        //}
        //htmx.logAll();

        // prevent browser trying to set scroll position on history restore
        //if ('scrollRestoration' in history) {
        //    history.scrollRestoration = 'manual';
        //}

        // Fix incorrect image srcset selection / missing video/audio controls in older versions of Safari
        // @see https://github.com/hotwired/turbo/issues/331
        // @see fixed in Webkit: https://github.com/WebKit/WebKit/commit/ebdff21ed51676ee81de66302692042d5bf8d6c4
        function safariBrowsingContextFix() {
            if (navigator.userAgent.match(/Version\/[\d.]+.*Safari/)) {
                const vArray = [...navigator.userAgent.split('Version/')[1]];
                const [first, second] = vArray;
                const version = first + second;
                if  (version <= 15) {
                    document.querySelectorAll('img,picture,audio,video').forEach((elm) => {
                        elm.outerHTML = elm.outerHTML; // eslint-disable-line no-param-reassign, no-self-assign
                    });
                }
            }
        }

        htmx.on('htmx:historyRestore', (event) => {
            safariBrowsingContextFix();
            htmx.config.boostCount++;
        });

        htmx.on('htmx:beforeSwap', (event) => {
            // disable smooth scrolling for 'main' element swaps
            if (event.target.id === 'main') {
                htmx.config.scrollBehavior = 'auto';
                htmx.config.defaultSettleDelay = 0;
            }
            if (event.target.id === 'listing') {
                //if ( window.innerWidth < 768) {
                //    htmx.config.scrollBehavior = 'auto';
                //    htmx.config.defaultSettleDelay = 0;
                //}
            }

            // @TODO - test needed: should we nuke Cookiebot's observer?
            // window.CookieConsent.stopMutationObserver();
        });

        htmx.on('htmx:afterSwap', () => {
            safariBrowsingContextFix();
        });

        htmx.on('htmx:afterSettle', (event) => {
            // re-enable smooth scrolling, if it was disabled
            if (event.target.id === 'main') {
                setTimeout(() => {
                    htmx.config.scrollBehavior = 'smooth';
                    htmx.config.defaultSettleDelay = 20;
                    // make sure we scroll to top
                    animateScrollTo(document.body).then(hasScrolledToPosition => {});
                }, 100);
            }
            if (event.target.id === 'listing') {
                //if ( window.innerWidth < 768) {
                //    setTimeout(() => {
                //        event.target.scrollIntoView({ behavior: "instant" });
                //        htmx.config.scrollBehavior = 'smooth';
                //        htmx.config.defaultSettleDelay = 20;
                //    }, 20);
                //}
            }
        });

        htmx.on('htmx:beforeRequest', (event) => {
            if (event.detail.boosted) {
                if (location.href === event.detail.pathInfo.requestPath) {
                    // scroll to top
                    window.scrollTo({top: 0, behavior: 'smooth'});
                    // prevent reloading the same page
                    event.preventDefault();
                    return false;
                } else {
                    // fresh page load to release memory on next boost
                    if (htmx.config.boostCount >= 50) {
                        event.preventDefault();
                        htmx.config.boostCount = 0;
                        window.location.href = event.detail.pathInfo.requestPath;
                    } else {
                        htmx.config.boostCount++;
                    }
                }
            }
        });

        htmx.on('htmx:historyCacheMissLoad', (event) => {
            // make sure we're at the top of the page
            window.scrollTo({top: 0, behavior: 'smooth'});
        });

        // handle response error
        htmx.on('htmx:responseError', (event) => {
            // hard redirect to final path, to let Craft handle it
            let path = event.detail.pathInfo.finalRequestPath ?? event.detail.pathInfo.finalPath ?? null;
            if (path) {
                try {
                    let redirectUrl = new URL(path);
                    if (redirectUrl) {
                        if (redirectUrl.origin === window.location.origin) {
                            window.location.href = path;
                        }
                    }
                } catch (e) {}
            }
        });

        // handle swap error
        htmx.on('htmx:swapError', (event) => {
            // hard redirect to final path, to let Craft handle it
            let path = event.detail.pathInfo.finalRequestPath ?? event.detail.pathInfo.finalPath ?? null;
            if (path) {
                try {
                    let redirectUrl = new URL(path);
                    if (redirectUrl) {
                        if (redirectUrl.origin === window.location.origin) {
                            window.location.href = path;
                        }
                    }
                } catch (e) {}
            }
        });

        (function () {

            let cache = {
                now : {},
                next : {}
            };

            function saveToCache(dom, store) {
                let markers = dom.querySelectorAll('[hx-history-preserve]');
                if (markers) {
                    for (let i=0; i<markers.length; ++i) {
                        if (typeof markers[i].id !== 'undefined') {
                            cache[store][markers[i].id] = markers[i].outerHTML;
                        }
                    }
                }
            }

            function rotateCache() {
                // Prune cache of any markers not found in current document
                let prunedCache = {};
                for (let key in cache.now) {
                    let el = document.getElementById(key);
                    if (el) {
                        prunedCache[key] = cache.now[key];
                    }
                    el = null;
                }
                cache.now = prunedCache;

                // Merge incoming cache, ready for the next history save
                if (Object.keys(cache.next).length > 0) {
                    cache.now = {
                        ...cache.now,
                        ...cache.next
                    };
                    cache.next = {};
                }
            }

            htmx.defineExtension('history-preserve', {

                init : function() {
                    // On page load, cache the initial dom state of preserved
                    // elements before they are manipulated by JS
                    saveToCache(document, 'now');
                },

                onEvent : function(name, event) {

                    if (name === "htmx:beforeSwap") {
                        // On swap, save the initial dom state of any preserved
                        // elements in the incoming DOM.
                        // We won't need this until the *next* request that
                        // triggers a history save
                        let incomingDOM = new DOMParser().parseFromString(event.detail.xhr.response, "text/html");
                        if (incomingDOM) {
                            saveToCache(incomingDOM, 'next');
                        }
                        incomingDOM = null;
                    }

                    if (name === "htmx:historyItemCreated") {
                        if (event.detail.item.content) {
                            // Overwrite content with our restored markup
                            // *before* it is saved to the history cache...
                            let cachedDOM = new DOMParser().parseFromString(event.detail.item.content, "text/html");
                            for (let key in cache.now) {
                                let el = cachedDOM.getElementById(key);
                                if (el) {
                                    el.outerHTML = cache.now[key];
                                }
                                el = null;
                            }
                            event.detail.item.content = cachedDOM.body.innerHTML;

                            // Rotate cache for next time
                            rotateCache();
                        }
                    }

                    if (name === 'htmx:historyRestore') {
                        // Update the cache of preserved elements that will be
                        // restored on the next request that triggers a history save
                        let restored = event?.detail?.item?.content;
                        if (restored) {
                            let restoredDOM = new DOMParser().parseFromString(restored, "text/html");
                            if (restoredDOM) {
                                saveToCache(restoredDOM, 'now');
                            }
                        }
                    }
                }
            });
        })();

        // This extension adds the X-Requested-With header to requests with the value "XMLHttpRequest".
        htmx.defineExtension('ajax-header', {
            onEvent: function (name, evt) {
                if (name === "htmx:configRequest") {
                    evt.detail.headers['X-Requested-With'] = 'XMLHttpRequest';
                }
            }
        });
    }
}